import Editor from "@monaco-editor/react";
import { useContext, useRef } from "react";
import { JSONataEditorContext } from "../contexts/JSONataEditorContext";

const jsonataLanguageConfig = {
      defaultToken: 'invalid',

      functions: [
        '$abs', '$acos', '$and', '$append', '$avg', '$base64Decode', '$base64Encode', '$ceil', '$contains',
        '$count', '$decodeUrl', '$encodeUrl', '$exists', '$filter', '$floor', '$join', '$keys', '$length',
        '$lookup', '$lowercase', '$map', '$match', '$max', '$min', '$not', '$now', '$number', '$or', '$power',
        '$random', '$reduce', '$reverse', '$round', '$sort', '$split', '$spread', '$sqrt', '$string',
        '$substring', '$sum', '$trim', '$type', '$uppercase', '$zip', '$distinct', '$substringBefore', 
        '$substringAfter', '$pad', '$contains', '$replace', '$eval', '$encodeUrlComponent','$decodeUrlComponent',
        '$formatNumber', '$formatBase', '$formatInteger', '$parseInteger', '$average', '$boolean', '$shuffle', 
        '$merge', '$sift', '$each', '$error', '$assert', '$millis', '$fromMillis', '$toMillis', '$single'
      ],

      keywords: [
        'true', 'false', 'null'
      ],

      operators: [
        "\\.", "\\*", "\\*\\*", "~>", "!", "\\$", "\\+", "-", "/", "%", ":=", "=",
        ">", "<", ">=", "<=", "!=", "and", "or", "\\?", "\\[", "\\]"
      ],

      symbols: /[=><!~?:&|+\-*\/\^%]+/,

      escapes: /\\(?:["\\/bfnrt]|u[0-9A-Fa-f]{4})/,

      tokenizer: {
        root: [
          [/\$[a-zA-Z_][\w-]*/, { cases: { '@functions': 'keyword' } }],
          [/\$[a-zA-Z_][\w-]*/, 'jsonata.variable'],
          [/[a-zA-Z_]+/, 'jsonata.normal'],
          [/[a-zA-Z_][\w-]*/, 'identifier'],

          { include: '@whitespace' },

          [/\d*\.\d+([eE][\-+]?\d+)?/, 'number.float'],
          [/0[xX][0-9a-fA-F]+/, 'number.hex'],
          [/\d+/, 'number'],

          [/@symbols/, {
            cases: {
              '@operators': 'operator',
              '@default': ''
            }
          }],

          [/[{}()\[\]]/, '@brackets'],
          [/,/, 'delimiter'],

          [/"([^"\\]|\\.)*$/, 'string.invalid'],
          [/"/, { token: 'string.quote', bracket: '@open', next: '@string' }],
          
          [/'([^'\\]|\\.)*$/, 'string.invalid'],
          [/'/, { token: 'string.quote', bracket: '@open', next: '@string_single' }],

          [/`([^`\\]|\\.)*$/, 'string.invalid'],
          [/`/, { token: 'string.quote', bracket: '@open', next: '@string_backtick' }],

          [/\.\*/, 'operator'],
          [/\*\*/, 'operator'],
          [/\*/, 'operator'],
          [/\?/, 'operator'],
        ],

        string: [
          [/[^\\"]+/, 'string'],
          [/@escapes/, 'string.escape'],
          [/\\./, 'string.escape.invalid'],
          [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
        ],
        string_single: [
          [/[^\\']+/, 'string'],
          [/@escapes/, 'string.escape'],
          [/\\./, 'string.escape.invalid'],
          [/'/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
        ],

        string_backtick: [
          [/[^\\`]+/, 'string'],          
          [/@escapes/, 'string.escape'],
          [/\\./, 'string.escape.invalid'],
          [/`/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
        ],


        whitespace: [
          [/[ \t\r\n]+/, 'white'],
          [/\/\/.*$/, 'comment'],
          [/\/\*/, 'comment', '@comment'],
        ],

        comment: [
          [/[^\/*]+/, 'comment'],
          [/\/\*/, 'comment', '@push'],
          ["\\*/", 'comment', '@pop'],
          [/[\/*]/, 'comment']
        ],
      }
    }

  const jsonataTheme = {
      base: 'vs',  
      inherit: true,  
      rules: [
        { token: 'jsonata.variable', foreground: 'FF6B6B', fontStyle: 'bold' },
        { token: 'jsonata.normal', foreground: 'FF6B6B', fontStyle: 'bold' },
      ],
      colors: {}
    }
export default function JSONataScriptEditor() {
  const { script, setScript } = useContext(JSONataEditorContext);
  const isLanguageRegistered = useRef(false);
  const handleEditorWillMount = (monaco) => {
    if (isLanguageRegistered.current) return;
    isLanguageRegistered.current = true;

    monaco.languages.register({ id: 'jsonata' });

    monaco.languages.setMonarchTokensProvider('jsonata', jsonataLanguageConfig);
    monaco.editor.defineTheme('jsonata-custom', jsonataTheme);
  }

  return (
    <Editor
      theme="jsonata-custom"
      defaultLanguage="jsonata"
      value={script}
      options={{
        lineNumbers: "off",
        minimap: { enabled: false },
        glyphMargin: false
      }}
      beforeMount={handleEditorWillMount}
      onChange={(value) => { setScript(value) }}
    />
  );
}